import { FunctionComponent } from "react";

export const RepareoLogo: FunctionComponent = () => {
  return (
    <a href={"https://www.repareo.com"} className={"flex"} title={"repareo Werkstattvergleich"}>
      <img src="/images/brand/logoBlack.svg" className="w-28 h-auto" alt="" />
    </a>
  );
};
